<template>
  <div class="home">
    <van-nav-bar
      class="nav"
      :title="$t('EditDish.title')"
      left-arrow
      fixed
      @click-left="$router.go(-1)"
    >
      <!-- @click-left="$router.push('/SetMenu')" -->
      <van-button
        slot="right"
        class="rightBtn"
        style="margin-right: 10px;"
        color="#1989fa"
        @click="patchDish()"
      >
        {{ $t("PackageDish.save") }}
      </van-button>
      <!-- <div slot="right">
        <van-icon
          name="./static/img/ok.png"
          slot="right"
          @click="patchDish()"
          style="font-size: 24px"
        />
      </div> -->
    </van-nav-bar>

    <div class="box">
      <van-cell-group>
        <!-- 分类 -->
        <van-field
          :value="tagStr"
          :label="$t('EditDish.category')"
          label-width="120"
          clearable
          :placeholder="$t('EditDish.noChoose')"
          readonly
        >
          <van-icon
            slot="right-icon"
            @click="isTagShow = true"
            size="25px"
            name="arrow"
          />
        </van-field>
        <!-- 主名稱 -->
        <van-field
          v-model="dish.name"
          :label="$t('EditDish.cookName')"
          label-width="120"
          clearable
          :placeholder="$t('EditDish.inputName')"
        />
        <!-- 副名稱 -->
        <van-field
          v-model="dish.name_en"
          :label="$t('EditDish.enName')"
          label-width="120"
          clearable
          :placeholder="$t('EditDish.inputName')"
        />
        <!-- 圖片 -->
        <van-cell
          :title="$t('EditDish.pic')"
          title-style="width: 117px;flex:none;"
        >
          <van-uploader :after-read="afterRead">
            <van-image
              v-if="img"
              width="55"
              fit="contain"
              height="55"
              :src="img"
            />
            <van-image
              v-else
              width="55"
              height="55"
              src="./static/img/add_img.png"
            />
          </van-uploader>
        </van-cell>
        <!-- 價格 -->
        <van-panel
          :title="$t('EditDish.price')"
          :status="$t('EditDish.status')"
        >
          <van-checkbox-group v-model="priceResult">
            <van-cell-group>
              <van-field
                v-model="dish.original_price"
                :label="$t('EditDish.oldPrice') + currency"
                clearable
                :placeholder="$t('EditDish.inputOldPrice')"
              >
                <van-checkbox
                  @click="togglePrice('o')"
                  :name="'o'"
                  ref="price_checkboxes"
                  slot="right-icon"
                >
                  <img
                    style="width: 20px; height: 20px"
                    slot="icon"
                    slot-scope="props"
                    :src="
                      props.checked
                        ? './static/img/sele.png'
                        : './static/img/unsele.png'
                    "
                  />
                </van-checkbox>
              </van-field>
              <van-field
                v-model="dish.special_price"
                :label="$t('EditDish.newPrice') + currency"
                clearable
                :placeholder="$t('EditDish.inputNewPrice')"
              >
                <van-checkbox
                  @click="togglePrice('s')"
                  :name="'s'"
                  ref="price_checkboxes"
                  slot="right-icon"
                >
                  <img
                    style="width: 20px; height: 20px"
                    slot="icon"
                    slot-scope="props"
                    :src="
                      props.checked
                        ? './static/img/sele.png'
                        : './static/img/unsele.png'
                    "
                  />
                </van-checkbox>
              </van-field>
            </van-cell-group>
          </van-checkbox-group>
        </van-panel>
        <!-- 推薦指數 -->
        <van-cell
          :title="$t('EditDish.commend')"
          title-style="width: 117px;flex:none;"
        >
          <van-rate
            style="height: 23px"
            v-model="dish.level"
            :size="20"
            gutter="10px"
            icon="./static/img/Recommend-s.png"
            void-icon="./static/img/Recommend.png"
          />
          <van-icon
            v-if="dish.level"
            slot="right-icon"
            name="cross"
            @click="dish.level = ''"
          />
        </van-cell>
        <!-- 偏好設置 -->
        <van-field
          :value="perferStr"
          :label="$t('EditDish.prefer')"
          label-width="120"
          clearable
          readonly
          placeholder="请选择"
        >
          <van-icon
            slot="right-icon"
            @click="isPerferShow = true"
            size="25px"
            name="arrow"
          />
        </van-field>

        <!-- <van-cell :title="$t('EditDish.prefer')" class="margin_top" is-link @click="isPerferShow=true"></van-cell>	 -->
        <!-- <van-cell v-if='isServer' :title="$t('EditDish.severce')" class="margin_top" is-link ></van-cell>	 -->
        <!-- 介紹 -->
        <van-field
          v-model="dish.introduction"
          type="textarea"
          autosize
          clickable
          :label="$t('EditDish.intro')"
          :placeholder="$t('EditDish.inputIntro')"
        />
        <!-- 选择打印机 -->
        <!--  <van-cell
			      	v-for="(item, index) in markList"
			      	clickable
			      	:key="index"
		 	     	:title="item"
			      	@click="toggle(index)"
			    >
			   		
	    		</van-cell>
 -->
        <!-- 打印機設置 -->
        <van-cell
          :title="$t('printerSet.title')"
          title-style="width: 120px;flex:none;"
        >
          <van-checkbox-group v-model="dish.mark" direction="horizontal">
            <van-checkbox name="A" shape="square"
              >{{ $t("printerSet.name") }} A</van-checkbox
            >
            <van-checkbox name="B" shape="square"
              >{{ $t("printerSet.name") }} B</van-checkbox
            >
            <van-checkbox name="C" shape="square"
              >{{ $t("printerSet.name") }} C</van-checkbox
            >
            <van-checkbox name="D" shape="square"
              >{{ $t("printerSet.name") }} D</van-checkbox
            >
            <van-checkbox name="E" shape="square"
              >{{ $t("printerSet.name") }} E</van-checkbox
            >
          </van-checkbox-group>
        </van-cell>
        <!-- 物品單位 -->
        <!-- <van-cell-group >-->
        <van-cell
          v-if="unitArr.length > 0"
          :title="$t('itemInfo.company')"
          value-class="valuestyle"
          :value="dish.unit"
          is-link
          @click="showLanguage = true"
        />
        <van-cell-group v-else>
          <van-field
            :label="$t('itemInfo.company')"
            readonly
            :value="$t('itemInfo.nodatamsg')"
          />
        </van-cell-group>
        <van-popup v-model="showLanguage" position="bottom">
          <van-picker
            show-toolbar
            :columns="unitArr"
            value-key="name"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="showLanguage = false"
            @confirm="onConfirm"
          />
        </van-popup>
        <!-- </van-cell-group> -->

        <!-- 條形碼 -->
        <van-cell-group>
          <van-field
            v-model="dish.code"
            :label="$t('itemInfo.barCode')"
            clearable
            center
            :placeholder="$t('itemInfo.barCode')"
            use-button-slot
          >
          </van-field>
        </van-cell-group>
      </van-cell-group>
      <!-- 偏好彈窗 -->
      <van-popup
        v-model="isPerferShow"
        position="bottom"
        :style="{ height: '70%' }"
      >
        <van-cell-group>
          <van-cell title="">
            <van-icon
              slot="icon"
              name="./static/img/dele_staff.png"
              size="25px"
              @click="isPerferShow = false"
            />
            <van-icon
              slot="right-icon"
              name="./static/img/ok1.png"
              size="25px"
              @click="perferTagShow()"
            />
          </van-cell>
        </van-cell-group>
        <van-checkbox-group v-model="perferResult">
          <van-cell-group>
            <template v-if="perfers.length > 0">
              <div v-for="(perfer, index) in perfers" :key="index">
                <van-cell
                  v-if="perfer.name !== null"
                  clickable
                  :key="index"
                  :title="perfer.name"
                  @click="toggle(index)"
                >
                  <van-checkbox
                    :name="perfer.id"
                    ref="checkboxes"
                    slot="right-icon"
                  >
                    <img
                      style="width: 20px; height: 20px"
                      slot="icon"
                      slot-scope="props"
                      :src="
                        props.checked
                          ? './static/img/sele.png'
                          : './static/img/unsele.png'
                      "
                    />
                  </van-checkbox>
                </van-cell>
              </div>
            </template>
          </van-cell-group>
        </van-checkbox-group>
      </van-popup>
      <van-popup
        v-model="isTagShow"
        position="bottom"
        :style="{ height: '70%' }"
      >
        <van-cell-group>
          <van-cell title="">
            <van-icon
              slot="icon"
              name="./static/img/dele_staff.png"
              size="25px"
              @click="isTagShow = false"
            />
            <van-icon
              slot="right-icon"
              name="./static/img/ok1.png"
              size="25px"
              @click="TagShow"
            />
          </van-cell>
          <p style="text-align: center; padding: 5px 0; margin: 0">
            {{ $t("EditDish.noChoose1") }}
          </p>
          <van-checkbox-group v-model="tagResult">
            <van-cell-group v-if="tags.length > 0">
              <van-cell
                v-for="(tag, index) in tags"
                clickable
                :key="index"
                :title="tag.name"
                v-show="tag.name !== null"
                @click="togglePerfer(index)"
              >
                <van-checkbox
                  :name="tag.id"
                  ref="perferboxes"
                  slot="right-icon"
                >
                  <img
                    style="width: 20px; height: 20px"
                    slot="icon"
                    slot-scope="props"
                    :src="
                      props.checked
                        ? './static/img/sele.png'
                        : './static/img/unsele.png'
                    "
                  />
                </van-checkbox>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-cell-group>
      </van-popup>

      <!-- 选择食材 -->
      <!-- <van-field
        v-model="dish.ingredients"
        :label="$t('EditDish.ingredients')"
        label-width="120"
        clearable 
        is-link
      /> -->
      <!-- 關聯產品 -->
      <van-cell
        title-style="width: 120px;flex:none;"
        :title="$t('ShopSet.Ingredients')"
        is-link
        @click="showIngreDialog = true"
      >
        <template v-if="foodChooseArr.length">
          <span v-for="(v, k) in foodChooseArr" :key="k">{{ v.name }}、</span>
        </template>
        <template v-else>
          <span>{{ $t("ShopSet.noIngredients") }}</span>
        </template>
      </van-cell>

      <!-- 關聯產品食材弹窗 -->
      <van-popup
        v-model="showIngreDialog"
        position="bottom"
        style="height: 40%"
      >
        <div class="ninew bodybox">
          <!-- 内容 -->
          <van-cell-group class="sixTop">
            <van-cell title="">
              <van-icon
                slot="right-icon"
                name="./static/img/ok1.png"
                size="25px"
                @click="submitfood"
              />
            </van-cell>
          </van-cell-group>

          <div v-if="goodsList.length">
            <van-cell-group v-for="(v, k) in goodsList" :key="k">
              <van-cell>
                <van-field
                  v-if="v.checked"
                  :label="v.name + '(' + v.unit.name + ')'"
                  clearable
                  v-model="v.foodNum"
                  :placeholder="$t('itemInfo.inputNumber')"
                />
                <van-field
                  v-else
                  :label="v.name + '(' + v.unit.name + ')'"
                  clearable
                  disabled
                  v-model="v.foodNum"
                  :placeholder="$t('itemInfo.inputNumber')"
                />
                <img
                  style="width: 20px; height: 20px"
                  slot="right-icon"
                  class="checkIcon"
                  :src="
                    v.checked
                      ? './static/img/sele.png'
                      : './static/img/unsele.png'
                  "
                  @click="changeCheckfood(v.id)"
                />
              </van-cell>
            </van-cell-group>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLanguage: false,
      showIngreDialog: false,
      foodChooseArr: [],
      goodsList: [],
      unitArr: [],
      dish: {},
      priceResult: [],
      img: "",
      perfers: [],
      tags: [],
      isPerferShow: false,
      isTagShow: false,
      perferResult: [],
      tagResult: [],
      tagStr: "",
      perferStr: "",
      isServer: false,
      currency: "",
      company_id: "" // 物品单位id
      // goodInfo: {
      //   store_id: sessionStorage.actShopId,
      //   name: "",
      //   name_en: "",
      //   image_id: "",
      //   original_price: "",
      //   special_price: "",
      //   level: 0,
      //   ids: "",
      //   // type: "o",
      //   introduction: "",
      //   category: 'm',
      //   mark: "",
      //   // ingredients: "",
      //   unit_id: 2
      // }
    };
  },
  mounted: function() {
    this.getList();
    this.getPerfers();
    this.getTags();
    this.getDish();
    this.getCurrency();
    this.getAllUnits();
  },
  methods: {
    // 获取单位id
    onConfirm(e) {
      this.dish.unit = e.name;
      this.showLanguage = false;
      this.company_id = e.id;
      this.dish.unit_id = e.id;
    },
    // 获取所有单位
    getAllUnits() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/unit/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res.data.data);
            this.unitArr = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {});
    },
    // 上传图片
    afterRead(file) {
      console.log("圖片信息", file);
      let formData = new FormData();
      formData.append("type", "shop");
      formData.append("file", file.file);
      this.$axios({
        method: "post",
        url: this.$build + "/api/image",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + sessionStorage.token
        },
        data: formData
      })
        .then(res => {
          console.log("上傳成功", res);
          if (res.data.status == 200) {
            this.dish.image_id = res.data.success.image_id;
            this.img = res.data.success.url;
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 獲取物品信息表  废弃
    getList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          `/api/goods/${sessionStorage.getItem("actShopId")}/index`
      })
        .then(res => {
          if (res.data.status == 200) {
            res.data.data.forEach(d => {
              d.checked = false;
              d.foodNum = 0;
            });
            this.goodsList = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {});
    },
    // 切换关联菜品相关
    changeCheckfood(id) {
      console.log(id);
      this.goodsList.forEach(v => {
        if (id == v.id) {
          v.checked = !v.checked;
        }
      });
    },
    // 关联菜品相关
    submitfood() {
      this.showIngreDialog = false;
      var newArr = [];
      this.goodsList.forEach(d => {
        if (d.checked) {
          newArr.push({
            store_goods_id: d.id,
            number: d.foodNum,
            name: d.name
          });
        }
      });
      this.foodChooseArr = newArr;
      console.log(this.foodChooseArr, "选中的食物");
    },
    // 获取当前菜品信息  在用
    getDish() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/" + this.$route.params.id + "/index"
      })
        .then(res => {
          console.log("&&&&&&", res.data.data);
          if (res.data.status == 200) {
            this.dish = res.data.data;
            if (res.data.data.image) {
              this.img = res.data.data.image.path;
              this.dish.image_id = res.data.data.image.id;
            }
            this.perferResult = res.data.data.perfer_id;

            this.tagResult = res.data.data.class_id;
            this.priceResult.push(res.data.data.type);
            var foodChooseArr = [];
            if (this.goodsList) {
              this.goodsList.forEach(k => {
                res.data.data.goods.forEach(v => {
                  if (v.store_goods_id == k.id) {
                    k.checked = true;
                    k.foodNum = v.number;
                    foodChooseArr.push({
                      number: v.number,
                      store_goods_id: k.id,
                      name: k.name
                    });
                  }
                });
              });
            }

            this.foodChooseArr = foodChooseArr;
            console.log(this.foodChooseArr, "獲取选中的食物");
            this.TagShow();
            this.perferTagShow();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 获取偏好设置
    getPerfers() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/tags/" +
          sessionStorage.actShopId +
          "/index/0/perfer"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.perfers = res.data.data;
            this.perferTagShow();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 获取分类数据
    getTags() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/tags/" +
          sessionStorage.actShopId +
          "/index/0/class"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.tags = res.data.data;
            this.TagShow();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 更新菜品
    patchDish() {
      this.bindGoods();
      this.dish.ids = JSON.stringify(this.perferResult.concat(this.tagResult));
      console.log("---------", this.dish.ids);
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/" + this.$route.params.id + "/update",
        data: this.dish
      })
        .then(res => {
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            const vm = this;
            setTimeout(function() {
              vm.$router.push("/SetMenu");
            }, 1500);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 绑定物品
    bindGoods() {
      var dataform = {
        menu_id: this.$route.params.id,
        goodsInfo: JSON.stringify(this.foodChooseArr)
      };
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        data: dataform,
        url: this.$build + "/api/menu/goods"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            console.log("綁定門店物品成功");
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    toggle(index) {
      console.log(index);
      this.$refs.checkboxes[index].toggle();
    },
    togglePerfer(index) {
      this.$refs.perferboxes[index].toggle();
    },
    // 获取原价或特价
    togglePrice(val) {
      this.priceResult = [];
      this.priceResult.push(val);
      this.dish.type = this.priceResult[0];
    },
    // 拼接分类
    TagShow() {
      this.isTagShow = false;
      this.tagStr = "";
      if (this.tags.length > 0) {
        for (let i = 0; i < this.tags.length; i++) {
          if (this.tagResult.length > 0) {
            for (let j = 0; j < this.tagResult.length; j++) {
              if (this.tagResult[j] == this.tags[i].id) {
                this.tagStr += this.tags[i].name + ",";
              }
            }
          }
        }
      }
    },
    // 拼接偏好设置
    perferTagShow() {
      this.isPerferShow = false;
      this.perferStr = "";
      if (this.perfers.length > 0) {
        for (let i = 0; i < this.perfers.length; i++) {
          if (this.perferResult.length > 0) {
            for (let j = 0; j < this.perferResult.length; j++) {
              if (this.perferResult[j] == this.perfers[i].id) {
                this.perferStr += this.perfers[i].name + ",";
              }
            }
          }
        }
      }
    },
    // 获取店铺设置的货币
    getCurrency() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/currency"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.currency = res.data.data.unit;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    }
  }
};
</script>
<style scoped>
.valuestyle {
  text-align: right !important;
}
/* 食材 */
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-cell .van-icon {
  font-size: 20px;
}
/deep/ .van-cell__value {
  font-size: 16px;
  /* text-align: center; */
}
/deep/ .van-field__control {
  font-size: 16px;
}

/deep/ .van-field__label {
  color: #323233;
}
.box {
  padding-bottom: 30px;
}
.home {
  width: 100%;
  height: 100vh;
}
.bn {
  border: none;
}
.margin_top {
  border-top: 3px solid #f3f5f7;
}
.shopBottom {
  position: absolute;
  bottom: 0;
  height: 60px;
  background: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cancelBtn {
  width: 30%;
  top: 10%;
  left: 5%;
  background: #dfdede;
  font-weight: bold;
  font-size: 16px;
}
.certainBtn {
  width: 30%;
  top: 10%;
  right: 5%;
  background: linear-gradient(90deg, #ffc914, #ffb20d);
  font-weight: bold;
  font-size: 16px;
}
.checkIcon {
  transform: translateY(12px);
}
/deep/ .van-field__label {
  width: 120px;
  margin-right: 0;
}
.van-cell__value {
  text-align: left;
}
.van-panel__header-value {
  text-align: right;
  color: #444;
}
.van-panel__header-value {
  padding-right: 0;
}
/deep/ .van-cell .van-checkbox {
  height: 28px;
  line-height: 28px;
}
/deep/ .van-cell .van-checkbox .van-icon {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/Shop/EditDish.vue